import { CurrencyPipe } from '@angular/common';
import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'localizedCurrency',
  standalone: true,
})
@Injectable({
  providedIn: 'root',
})
export class LocalizedCurrencyPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(
    value: any,
    currencyCode?: string,
    display?: string,
    digitsInfo?: string
  ): any {
    const currencyPipe: CurrencyPipe = new CurrencyPipe(
      this.translateService.currentLang
    );

    return currencyPipe.transform(value, currencyCode, display, digitsInfo);
  }
}
